import { FC } from "react"
import { Component } from "../../types/ContentStructure"
import { SxProps } from "@mui/material"
import ComponentBannerText from "./ComponentBannerText"

interface IComponentBannerTextLogoProps {
    component: Component
    sx?: SxProps
}

const ComponentBannerTextLogo: FC<IComponentBannerTextLogoProps> = ({ component, sx }) => {
    return (<ComponentBannerText component={component} />)
}

export default ComponentBannerTextLogo
